<template>
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" style="max-width:1200px;">
            <div class="modal-content" style="min-height: 550px;">
                <div class="modal-header">
                    <h2>{{titulo}}</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">
                        <div class="col-12 col-sm-12 col-lg-8">
                            <div class="form-group">
                                <label for="matricula" class="form-check-label">Aluno:</label>
                                <Multiselect v-model="matriculaId" :filterResults="false" :minChars="3" :resolveOnLoad="true"
                                    :delay="500" :searchable="true"
                                    :options="async function(query) { return await buscarAluno(query) }"
                                    noOptionsText="Nenhum item encontrado" />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label for="dataAvaliacao" class="form-check-label">Data da Avaliacao:</label>
                                <input required type="date" class="form-control" v-model="dataAvaliacao">
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label for="dataSolicitacao" class="form-check-label">Data da Solicitacao:</label>
                                <input required type="date" class="form-control" v-model="dataSolicitacao">
                            </div>
                        </div>
                        <div class="col-12 col-sm-12">
                            <div class="form-group">
                                <label for="justificativa" class="form-check-label">Justificativa:</label>
                                <textarea required rows="4" class="form-control" v-model="justificativa"></textarea>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12">
                            <div class="form-group">
                                <label for="parecer" class="form-check-label">Parecer:</label>
                                <textarea rows="3" class="form-control" v-model="parecer"></textarea>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12" v-if="status">
                            <div class="form-group">
                                <label for="status_id" class="form-check-label">Status:</label>
                                <Multiselect v-model="statusId" :options="status_select" :searchable="true"></Multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BotaoSalvar @click="salvar" :processando="processando"></BotaoSalvar>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import SegundaChamadaService from "@/service/v1/sigap/SegundaChamadaService"
import MatriculaService from "@/service/v1/sigap/MatriculaService"
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop } from 'vue-property-decorator';

@Options({
    name: "SegundaChamadaCadastro",
    components: { Multiselect, BotaoSalvar },
    emits: ['segunda-chamada-criada'],
})
export default class SegundaChamadaCadastro extends Vue {
    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly disciplina!: any

    public service = new SegundaChamadaService();
    public matriculaService = new MatriculaService();

    public processando = false;
    public titulo = 'Cadastrar Segunda Chamada';

    public matriculaId: any = null;
    public dataAvaliacao: any = null;
    public dataSolicitacao: any = null;
    public justificativa: any = null;
    public parecer: any = null;
    public statusId: any = null;
    public status: any = null;

    created() {
        this.getStatus();
    }

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => { return { value: item.id, label: item.nome } });
        }
        return null;
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
            });
    }

    public async buscarAluno(query) {
        if (query) {
            const response = await this.matriculaService.getAllWithUsuario("turmaId=" + this.disciplina?.turmaId + "&Take=200&search=" + query);
            return response.data.map((item) => {
                return { value: item.id, label: item.numeroCurso + (item.isRemanescente ? '(R)' : '') + ' - ' + item.usuario.nome + ' - RG ' + item.usuario.rg + ' ( ' + item.pelotao + 'º pelotão)' }
            })
        }
        return [];
    }

    public getdados() {
        let dados: any = {};
        dados.matriculaId = this.matriculaId;
        dados.disciplinaId = this.disciplina.id;
        dados.dataAvaliacao = this.dataAvaliacao;
        dados.dataSolicitacao = this.dataSolicitacao;
        dados.justificativa = this.justificativa;
        dados.parecer = this.parecer;
        dados.status = this.statusId;
        return dados;
    }

    public sucesso() {
        this.$emit("segunda-chamada-criada", null);
        this.matriculaId = null;
        this.dataAvaliacao = null;
        this.dataSolicitacao = null;
        this.justificativa = null;
        this.parecer = null;
        this.statusId = null;
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) {
            return;
        }
        if (!this.matriculaId || !this.dataAvaliacao || !this.dataSolicitacao || !this.justificativa || !this.statusId) {
            SiteUtils.toastErro('Error!', 'Preencha os campos obrigatorios.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
</script>
